import React from "react";
import { UserCircle2 } from "lucide-react";
import TableActionButtons from '../../CommonComponents/TableActionButtons';
import EmptyState from '../../CommonComponents/EmptyState';
import { Package } from 'lucide-react';
import { resolveAssetUrl } from "../../../utils/assetUrl";

export default function UserTable({ users, onPreviewProfile, onEdit, onDelete, onToggleStatus, loading }) {
    return (
        <div className="overflow-x-auto rounded-[28px] border border-slate-200/80 bg-white shadow-[0_18px_45px_rgba(15,23,42,0.06)]">
            <table className="min-w-[1080px] w-full border-collapse lg:min-w-[980px] xl:min-w-0">
                <thead
                    className="border-b"
                    style={{
                        background: "linear-gradient(180deg, var(--color-primary), color-mix(in srgb, var(--color-primary) 82%, black))",
                        borderColor: "color-mix(in srgb, var(--color-primary) 72%, black)",
                    }}
                >
                    <tr>
                        <th className="px-4 py-3 text-left text-[10px] font-semibold uppercase tracking-[0.18em] text-white/90 xl:px-5">No.</th>
                        <th className="px-4 py-3 text-center text-[10px] font-semibold uppercase tracking-[0.18em] text-white/90 xl:px-5">Profile</th>
                        <th className="px-4 py-3 text-left text-[10px] font-semibold uppercase tracking-[0.18em] text-white/90 xl:px-5">Username</th>
                        <th className="px-4 py-3 text-left text-[10px] font-semibold uppercase tracking-[0.18em] text-white/90 xl:px-5">Email</th>
                        <th className="px-4 py-3 text-left text-[10px] font-semibold uppercase tracking-[0.18em] text-white/90 xl:px-5">Role</th>
                        <th className="px-4 py-3 text-left text-[10px] font-semibold uppercase tracking-[0.18em] text-white/90 xl:px-5">Branch</th>
                        <th className="px-4 py-3 text-left text-[10px] font-semibold uppercase tracking-[0.18em] text-white/90 xl:px-5">Status</th>
                        <th className="px-4 py-3 text-center text-[10px] font-semibold uppercase tracking-[0.18em] text-white/90 xl:px-5">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr><td colSpan={8} className="px-6 py-12 text-center text-sm text-slate-500">Loading...</td></tr>
                    ) : users.length === 0 ? (
                        <tr>
                            <td colSpan={8} className="px-6 py-12 text-center">
                                <EmptyState icon={Package} message="No users found." size="default" />
                            </td>
                        </tr>
                    ) : (
                        users.map((user, idx) => (
                            <tr
                                key={user.id}
                                className={`border-b border-slate-100 bg-slate-50/85 transition hover:bg-emerald-50/70 even:bg-white last:border-0 sm:bg-transparent sm:hover:bg-slate-50/70 sm:even:bg-transparent ${user.status === "DELETED" ? "opacity-50" : ""}`}
                            >
                                <td className="px-4 py-2.5 text-left text-sm text-slate-700 xl:px-5">{idx + 1}</td>
                                <td className="px-4 py-2.5 text-center xl:px-5">
                                    <button
                                        type="button"
                                        onClick={() => onPreviewProfile?.(user)}
                                        className="inline-flex h-11 w-11 items-center justify-center overflow-hidden rounded-full border border-slate-200 bg-slate-50 shadow-sm transition hover:scale-[1.03] hover:border-slate-300 hover:bg-slate-100 focus:outline-none"
                                        aria-label={`Preview ${user.username}'s profile picture`}
                                    >
                                        {resolveAssetUrl(user.profile_image) ? (
                                            <img
                                                src={resolveAssetUrl(user.profile_image)}
                                                alt={`${user.username} profile`}
                                                className="h-full w-full object-cover"
                                            />
                                        ) : (
                                            <UserCircle2 className="h-6 w-6 text-slate-400" />
                                        )}
                                    </button>
                                </td>
                                <td className="px-4 py-2.5 text-left text-sm font-semibold text-slate-900 xl:px-5">{user.username}</td>
                                <td className="px-4 py-2.5 text-left text-sm text-slate-600 xl:px-5">{user.email}</td>
                                <td className="px-4 py-2.5 text-left text-sm text-slate-700 xl:px-5">{user.role}</td>
                                <td className="px-4 py-2.5 text-left text-sm text-slate-700 xl:px-5">{user.branch?.name || user.branch_name || user.branch?.location || user.branch_id || '-'}</td>
                                <td className="px-4 py-2.5 text-left xl:px-5">
                                    <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${user.status === "ACTIVE"
                                        ? "bg-green-100 text-green-600"
                                        : user.status === "INACTIVE"
                                            ? "bg-gray-200 text-gray-400"
                                            : "bg-red-100 text-red-600"
                                        }`}>
                                        {user.status}
                                    </span>
                                </td>
                                <td className="px-4 py-2.5 text-center xl:px-5">
                                    <div className="flex items-center justify-center gap-3">
                                        {user.status !== "DELETED" && (
                                            <>
                                                <TableActionButtons
                                                    canEdit
                                                    canDelete
                                                    canToggle
                                                    onEdit={() => onEdit(user)}
                                                    onDelete={() => onDelete(user)}
                                                    onToggle={() => onToggleStatus(user)}
                                                    toggleStatus={user.status}
                                                    toggleBeforeEdit
                                                />
                                            </>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}
